export default {
    post6668f5d1d434e : '6668f5d1d434e', //��¼ע��-�����֤�뻷��
    post666a45d4d6bb4 : '666a45d4d6bb4', //��¼ע��-������֤��-��ȫУ��
    post5c78dca45ebc1 : '5c78dca45ebc1', //��¼ע��-��֤���¼
    post5caeeba9866aa : '5caeeba9866aa', //��¼ע��-�������루�������룩
    post5c78dbfd977cf : '5c78dbfd977cf', //��¼ע��-�˺������¼
    post5cad9f63e4f94 : '5cad9f63e4f94', //��¼ע��-��Աע��
    post5c78c4772da97 : '5c78c4772da97', //��������-��ȡ��Ա��ϸ��Ϣ
    post68e6215c5a333 : '68e6215c5a333', //��ȡ�ײ������б�
    post641e624160dd0 : '641e624160dd0', //��ҳ�ֲ�ͼ
    post68e4adcb2856f : '68e4adcb2856f', //ϵͳ����-��ȡ�����������ò���
    post641568f1b6f87 : '641568f1b6f87', //ϵͳ����--��ȡϵͳ��ҳ����
    post68d271a2aef69 : '68d271a2aef69', //��ȡ�ײ��б�
    post68d3bf9d40c03 : '68d3bf9d40c03', //��ȡ��Ա��Ʊ�ʲ�
    post68e4b3ce32281 : '68e4b3ce32281', //��ȡ�ײ�����
    post636f7683cf195 : '636f7683cf195', //��ַ�б�
    post637defdbd53ef : '637defdbd53ef', //��ַ����-���ӵ�ַ
    post637df1ea39d16 : '637df1ea39d16', //��ַ����-�༭��ַ
    post636f773e8d763 : '636f773e8d763', //��ַ����-ɾ����ַ
    post636fd7826b3ee : '636fd7826b3ee', //��ַ����-��ȡ��ַ��Ϣ
    post68d8f52b8968f : '68d8f52b8968f', //�µ������ײ�
    post68db409061aa4 : '68db409061aa4', //��ѯ�ײͶ���ԤԼʱ���б�
    post68db3e68c732a : '68db3e68c732a', //��ѯ�������ײͶ����б�
    post68d91e207c067 : '68d91e207c067', //��ȡ�ײͶ�������
    post68e779ab8465c : '68e779ab8465c', //ȡ������-�ײͶ���
    post68d91ca0dd880 : '68d91ca0dd880', //��ѯ��ʷ�ײͶ����б�
    post68db493363a59 : '68db493363a59', //��ѯ�ҵ�ԤԼ-����һ��Ķ���
    post68d0b9d0dacb2 : '68d0b9d0dacb2', //��ȡ��ҵ����Ϣ
    post68caa25b2cb19 : '68caa25b2cb19', //��ѯ��ҵ�б�
    post68d0ab0b58894 : '68d0ab0b58894', //�ύ��ҵ��
    post68d251dcbf491 : '68d251dcbf491', //��ȡ��Ʊ��ϸ��¼
    post68d508a33bd92 : '68d508a33bd92', //�鿴��ֵ����-��Ʊ����
    post68d2173c73087 : '68d2173c73087', //��ȡ��Ʊ��ֵ�б�
    post68d4ffd86eaa5 : '68d4ffd86eaa5', //��Ʊ��ֵ�ύ����
    post5da9ab4c4c7af : '5da9ab4c4c7af', //У������
    post5f6db4db8abcf : '5f6db4db8abcf', //��������-У����֤��
    post5f6c915d69d1f : '5f6c915d69d1f', //У�����ֻ���
    post68e481f4338e7 : '68e481f4338e7', //�����Զ����ۿ���
    post64241ca6cf066 : '64241ca6cf066', //ϵͳ��Ϣ-��ȡδ����Ϣ�Ǳ�
    post6415752f56d0f : '6415752f56d0f', //ϵͳ��Ϣ-��Ϣ�б�
    post6424280846288 : '6424280846288', //ϵͳ��Ϣ-������Ϣ�б�
    post641576c24de11 : '641576c24de11', //��ȡ��������
    post63feb2ce76ac6 : '63feb2ce76ac6', //���֧��
    post68e48e514b1bc : '68e48e514b1bc', //��������-�޸����� 
    post693f840684f1a : '693f840684f1a', //��ȡstripe֧��
	       
}
